import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HouseSvgComponent, KeySvgComponent, OfficeSvgComponent } from '@uc/shared/svg';
import { Product } from '@uc/web/shared/data-models';
import { VisitWebsiteBtnService } from '@web/shared/ui';

@Component({
	selector: 'uc-no-accommodation',
	templateUrl: './no-accommodation.component.html',
	imports: [HouseSvgComponent, KeySvgComponent, OfficeSvgComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccommodationComponent {
	universityExternalUrl = input.required<string>();
	uniId = input.required<number | null>();
	uniName = input.required<string>();
	ugSearchOrderPosition = input.required<number | null>();
	product = input.required<Product | null>();

	constructor(private _visitWebsiteBtnSrv: VisitWebsiteBtnService) {}

	onVisitWebsiteClick() {
		this._visitWebsiteBtnSrv.onVisitWebsiteClick(
			this.uniId(),
			this.uniName(),
			'Accommodation Empty State',
			this.ugSearchOrderPosition(),
			'uni',
			this.product(),
		);
	}
}
